import React from "react";
import {Breadcrumbs, RequestResetPasswordPage} from "peggirkit";
import {authPageProps} from "@widgets/auth/AuthenticationPage";
import {useIntl} from "react-intl";
import router from "@/routing/Router";
import {ArrowUturnLeftIcon} from "@heroicons/react/20/solid";
import {api} from "@/data/api";

const RequestResetPassword = () => {
    const intl = useIntl();
    const submitRequestReset = (username: string): Promise<void> => new Promise((resolve, reject) => {
        api.auth.requestPasswordReset(username)
            .then(() => resolve())
            .catch(() => reject())
    });

    return (
        <RequestResetPasswordPage
            {...authPageProps("resetPassword", intl)}
            breadcrumbs={
                <Breadcrumbs
                    pages={[
                        {href: router.signIn.absolutePath(), name: intl.formatMessage({id: "signIn"})},
                        {href: router.reset.absolutePath(), name: intl.formatMessage({id: "resetPassword"})},
                    ]}
                    usePrevPageLink={true}
                    prevPageIcon={ArrowUturnLeftIcon}
                />
            }
            title={intl.formatMessage({id: "resetPassword"})}
            description={intl.formatMessage({id: "resetPasswordInstructions"})}
            usernameField={{
                displayName: intl.formatMessage({id: "emailAddress"}),
                type: "email",
                inputControlProps: {
                    placeholder: intl.formatMessage({id: "emailAddressPlaceholder"}),
                    tip: intl.formatMessage({id: "emailAddressOfExistingAccount"}),
                },
                options: {
                    required: intl.formatMessage({id: "enterAnEmailAddress"}),
                    minLength: {
                        value: 3,
                        message: intl.formatMessage({id: "mustBeMinCharacters"}, {min: 3})
                    },
                    maxLength: {
                        value: 128,
                        message: intl.formatMessage({id: "mustBeMaxCharacters"}, {max: 128})
                    }
                },
            }}
            submitButtonTxt={intl.formatMessage({id: "requestReset"})}
            errorMessage={intl.formatMessage({id: "errorRequestingReset"})}
            successMessage={intl.formatMessage({id: "passwordResetRequestedCheckInbox"})}
            onSubmit={submitRequestReset}
        />
    );
};

export default RequestResetPassword;